import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppBar, Box, IconButton, styled, Toolbar } from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import { Dashboard } from "@mui/icons-material";
import navBarStyle, {
	AdminButtons,
	AppBarRoot,
	CustomButtonInsc,
	NavBarRoot,
} from "./NavBarStyle";
import { ReactComponent as Logo } from "../../theme/icons/logo-nou.svg";
import { SvgIcon } from "@mui/material";

const Wrapper = styled("div")(({ theme }) => ({
	display: "flex",
	flex: "1",
	overflow: "hidden",
}));

const ContentContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flex: "1 1 auto",
	overflow: "hidden",
}));

const Content = styled("div")(({ theme }) => ({
	flex: "1 1 auto",
	height: "100%",
	overflow: "auto",
}));

const PublicNavBar = () => {
	const classes = navBarStyle();
	const [scrollY, setScrollY] = useState(window.scrollY);
	const [isLogged, setIsLogged] = useState(
		localStorage.getItem("isLoggedIn") === "true",
	);
	let navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	});

	const handleScroll = () => {
		setScrollY(window.scrollY);
	};

	useEffect(() => {
		setIsLogged(localStorage.getItem("isLoggedIn") === "true");
	}, [location.pathname]);

	const logOut = () => {
		localStorage.removeItem("user");
		localStorage.removeItem("isLoggedIn");
		setIsLogged(false);
		navigate("/");
	};

	return (
		<NavBarRoot>
			<AppBarRoot elevation={0}>
				<Toolbar
					className={classes.toolbar}
					style={{ alignItems: "center", justifyContent: "center" }}
				>
					{location.pathname === "/" ? (
						<>
							<CustomButtonInsc
								onClick={() => navigate("/contacte")}
							>
								Contacte / Baixa
							</CustomButtonInsc>
							<CustomButtonInsc
								onClick={() => navigate("/inscripcions")}
							>
								Inscripcions i horaris
							</CustomButtonInsc>
						</>
					) : (
						<>
							<Box
								my={2}
								onClick={() => navigate("/")}
								className={
									scrollY < 100
										? classes.showTitle
										: classes.hideTitle
								}
								style={{
									cursor: "pointer",
									textAlign: "center",
								}}
							>
								<SvgIcon
									component={Logo}
									viewBox="0 0 23 26"
									className={classes.icon}
								/>
							</Box>
						</>
					)}

					{isLogged === "true" && (
						<AdminButtons>
							<IconButton
								color="inherit"
								onClick={() => navigate("/admin/alumnes")}
							>
								<Dashboard />
							</IconButton>
							<IconButton
								color="inherit"
								onClick={() => logOut()}
							>
								<InputIcon />
							</IconButton>
						</AdminButtons>
					)}
				</Toolbar>
			</AppBarRoot>
			<Wrapper>
				<ContentContainer>
					<Content>
						<Outlet />
					</Content>
				</ContentContainer>
			</Wrapper>
		</NavBarRoot>
	);
};

export default PublicNavBar;
